import { hasPermission } from '../../src/directives/hasPermission'
export default {
    directives: {
        hasPermission
    }
  }
